import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function PackageReturnIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 32.5 31.513'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_46"
        data-name="Tracé 46"
        d="M2.854,8.473l14.557-6.4-.882.115L31.212,7.848l-.684-.526c-.2-.313-.027-.586-.056-.24-.014.172,0,.353,0,.526V9.337q0,2.743,0,5.487,0,3.965,0,7.929.283-.494.567-.988L18.2,28.088l-1.832.9,1.722.988q-.061-7.2-.122-14.391-.009-1.048-.018-2.1a1.192,1.192,0,0,0-.84-1.1L2.581,6.38a1.152,1.152,0,0,0-1.449,1.1v9.081a1.145,1.145,0,0,0,2.289,0V7.484l-1.449,1.1L16.5,14.6l-.84-1.1q.061,7.2.122,14.391.008,1.048.018,2.1a1.158,1.158,0,0,0,1.722.988l12.839-6.323,1.832-.9a1.132,1.132,0,0,0,.567-.988q0-5.138,0-10.276V7.339a1.615,1.615,0,0,0-.94-1.7c-.3-.137-.621-.24-.929-.358L19.3.811c-.957-.369-2.069-1.087-3.087-.7-1.264.481-2.493,1.1-3.731,1.641L1.7,6.5c-1.345.591-.182,2.565,1.155,1.976"
        transform="translate(-0.261 0)"
        fill="#333"
      />
      <rect
        id="Rectangle_37"
        data-name="Rectangle 37"
        width="2.289"
        height="15.322"
        transform="translate(9.37 4.896) rotate(-65.773)"
        fill="#333"
      />
      <rect
        id="Rectangle_38"
        data-name="Rectangle 38"
        width="16.212"
        height="2.289"
        transform="matrix(0.913, -0.407, 0.407, 0.913, 16.08, 12.448)"
        fill="#333"
      />
      <path
        id="Tracé_47"
        data-name="Tracé 47"
        d="M3.283,36.8a.747.747,0,0,1-.581-.25.9.9,0,0,1-.226-.632A.872.872,0,0,1,2.7,35.3a.752.752,0,0,1,.581-.247H8.647a3.231,3.231,0,0,0,2.371-1,3.587,3.587,0,0,0,0-4.959,3.234,3.234,0,0,0-2.371-1h-5.7l1.643,1.772a.951.951,0,0,1,.223.623.786.786,0,0,1-.239.6.717.717,0,0,1-.549.264.725.725,0,0,1-.55-.259L.492,27.837a.685.685,0,0,1-.185-.272.985.985,0,0,1-.056-.345.944.944,0,0,1,.056-.326.684.684,0,0,1,.185-.275L3.47,23.341a.766.766,0,0,1,1.116,0,.925.925,0,0,1,0,1.219l-1.643,1.8H8.627a4.736,4.736,0,0,1,3.5,1.508,5.4,5.4,0,0,1,0,7.416,4.733,4.733,0,0,1-3.5,1.511Z"
        transform="translate(-0.059 -5.474)"
        fill="#333"
      />
      <path
        id="Tracé_48"
        data-name="Tracé 48"
        d="M8.567,36.928H3.224a.934.934,0,0,1-.722-.313,1.1,1.1,0,0,1-.276-.76,1.064,1.064,0,0,1,.277-.741.937.937,0,0,1,.721-.309H8.588a3.065,3.065,0,0,0,2.237-.942,3.4,3.4,0,0,0,0-4.689,3.065,3.065,0,0,0-2.237-.942H3.321l1.346,1.452a1.143,1.143,0,0,1,.274.752.978.978,0,0,1-.3.732.9.9,0,0,1-1.373,0L.292,27.907a.849.849,0,0,1-.224-.334A1.225,1.225,0,0,1,0,27.16a1.173,1.173,0,0,1,.068-.389.873.873,0,0,1,.237-.353l2.966-3.265a.954.954,0,0,1,1.391-.005,1.116,1.116,0,0,1,.005,1.482L3.316,26.11H8.567a4.94,4.94,0,0,1,3.641,1.566,5.588,5.588,0,0,1,0,7.683,4.937,4.937,0,0,1-3.641,1.569M3.224,35.186a.564.564,0,0,0-.439.185.689.689,0,0,0-.177.484.721.721,0,0,0,.178.5.559.559,0,0,0,.439.187H8.567a4.568,4.568,0,0,0,3.369-1.454,5.207,5.207,0,0,0,0-7.149,4.573,4.573,0,0,0-3.369-1.451H2.452l1.933-2.12a.691.691,0,0,0,.179-.473.677.677,0,0,0-.18-.49.575.575,0,0,0-.836.006L.574,26.688a.518.518,0,0,0-.146.212.779.779,0,0,0-.046.26.815.815,0,0,0,.046.281.5.5,0,0,0,.134.2l2.991,3.273a.514.514,0,0,0,.816,0,.608.608,0,0,0,.191-.467.758.758,0,0,0-.179-.5L2.447,27.852H8.588A3.432,3.432,0,0,1,11.094,28.9a3.778,3.778,0,0,1,0,5.229,3.432,3.432,0,0,1-2.507,1.053Z"
        transform="translate(0 -5.415)"
        fill="#333"
      />
      <path
        id="Tracé_49"
        data-name="Tracé 49"
        d="M32.145,27.322l3.528-1.512a.924.924,0,0,0,.472-.823l-.252-5.04a.974.974,0,0,0-.954-.954.963.963,0,0,0-.954.954l.252,5.04.472-.823-3.528,1.512a.96.96,0,0,0-.342,1.306.979.979,0,0,0,1.3.342"
        transform="translate(-7.28 -4.501)"
        fill="#333"
      />
    </SvgIcon>
  );
}
